import canPayOnlinePayment from "web/utils/page/product/universal/canPayOnlinePayment";

import parsePaymentSettings, {
  type PaymentSettingsInput,
} from "./parsePaymentSettings";

export type PaymentFinancingMode =
  | "FULL_POINTS"
  | "POINTS_WITH_SURCHARGE"
  | "OWN_FUNDS"
  | "HIDDEN";

const getPaymentFinancingMode = (
  price: number,
  availableTotal: number,
  paymentSettings?: PaymentSettingsInput
): PaymentFinancingMode => {
  const settings = parsePaymentSettings(paymentSettings);
  const canBePaidByMoney = !!canPayOnlinePayment(settings);

  if ((availableTotal < price && !canBePaidByMoney) || price === 0) {
    return "HIDDEN";
  }

  if (availableTotal >= price) {
    return "FULL_POINTS";
  }

  if (availableTotal < price && canBePaidByMoney && availableTotal !== 0) {
    return "POINTS_WITH_SURCHARGE";
  }

  return "OWN_FUNDS";
};

export default getPaymentFinancingMode;
